<template>
  <div class="tab-management-container">
    <div ref="topicManagementBody" class="tab-management-container__body">
      <div class="tab-management-container__body--section">
        <div class="tab-management-container__body--section--header">
          <h2 class="title">Change Name</h2>
        </div>
        <input type="text" class="tab-management-container__body--section--input" placeholder="Topic name" v-model="topicName" name="" id="" :disabled="!changeTopicNamePermission.includes(topicToBeManage?.permission)"/>
      </div>
      <div class="tab-management-container__body--section">
        <div class="tab-management-container__body--section--header">
          <h2 class="title">Privacy Settings</h2>
        </div>
        <div class="privacy-settings">
          <div class="privacy-settings__header">
            <div class="privacy-settings__header--name">
              <template v-if="!topicToBeManage?.is_private">
              <img src="@/assets/icons/public-icon.svg" />
              <p>Public</p>
              </template>
              <template v-else>
                <img src="@/assets/icons/private-icon.svg" />
                <p>Private</p>
              </template>
            </div>
            <!-- :class="{'public-topic-active': type === 'Public' && audienceChoice === 'public'}" -->
            <a-select ref="select" v-model:value="audienceChoice" class="privacy-settings__header--select" :disabled="!changeTopicTypePermission.includes(topicToBeManage?.permission)">
              <a-select-option  value="public" @click.stop>
                <div class="select-item">
                  <img
                    src="@/assets/icons/public-icon.svg"
                    style="width: 1.6rem; margin-right: 0.9rem;"
                    class="black-icon"
                  />
                  <img
                    src="@/assets/icons/public-icon-white.svg"
                    style="width: 1.6rem; margin-right: 0.9rem; display: none;"
                    class="white-icon"
                  />Public
                </div>
              </a-select-option>
              <!-- :class="{'public-topic-active': type === 'Private' && audienceChoice === 'private'}" -->
              <a-select-option  value="private" @click.stop>
                <div  
                class="select-item">
                  <img
                    src="@/assets/icons/private-icon.svg"
                    style="width: 1.6rem; margin-right: 0.9rem;"
                    class="black-icon"
                  />
                  <img
                    src="@/assets/icons/private-icon-white.svg"
                    style="width: 1.6rem; margin-right: 0.9rem; display: none;"
                    class="white-icon"
                  />Private
                </div>
              </a-select-option>
            </a-select>
          </div>
          <!-- <div class="privacy-settings__body">
            <p>
              Public Topics are coming soon to Glocal.They will help you in
              opening public discussions to specific topics and get much better
              insights on them.
            </p>
          </div> -->
        </div>
      </div>
      <!-- start topic management new UI -->
      <manage-topics-roles
        v-if="topicToBeManage?.is_private"
        v-click-outside="handleClickOutside" 
        ref="manageTopicRoles"
        module="TopicManagement"
        :preSelectedUsers="preSelectedUsers"
        :userOptions="topicNonInvitedUsers"
        @pendingOrUpdateUsers="fetchUpdateTopicMembers"
        @fetchSelectedUser="fetchNewlyAddedTopicMembers"
        @removeUser="removeUser"
        @searchUser="searchUser"
        :searchLoader="searchUserLoader"
      />
      <topic-invite-via-email
        v-if="addNewUserPermission.includes(topicToBeManage?.permission)"
        @changeSelectedUsers="updateSelectedEmails"
      ></topic-invite-via-email>
       <!-- end topic management new UI -->
    </div>
    <div class="tab-management-container__footer">
      <a-button v-if="topicToBeManage?.permission === 'contributor'" :loading="requestEditorAccessLoader" @click="requestForEditorAccess" class="apply-btn">Request Editor Access</a-button>
      <a-button v-if="topicToBeManage?.permission === 'contributor' ||  topicToBeManage?.permission === 'editor'" :loading="requestAdminAccessLoader" @click="requestForAdminAccess" class="apply-btn">Request Admin Access</a-button>
      <a-button v-if="topicToBeManage?.permission === 'admin' ||  topicToBeManage?.permission === 'editor'" :disabled="disableButton" :loading="loader" @click="sendInvitation" class="apply-btn">Apply Changes</a-button>
    </div>
  </div>

  <delete-modal
    :visible="removeUserModal"
    @handle-close="removeUserModal = false"
    title="Are you sure you want to remove this?"
    confirmText="Yes, Remove"
    cancelText="No, Don't Remove"
    @delete-record="removeExistingUser"
    :loading="deleteLoader"
  ></delete-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import ManageTopicsRoles from "@/components/BaseComponents/sourcesFilters/ManageTopicsRoles.vue";
import DeleteModal from '@/components/BaseComponents/DeleteModal.vue';
import TopicInviteViaEmail from "./TopicInviteViaEmail.vue";

export default {
  components: {
    ManageTopicsRoles,
    DeleteModal,
    TopicInviteViaEmail
  },
  props: {
    topicToBeManage: Object
  },
  data() {
    return {
      audienceChoice: "Change Type",
      contactOptions: [],
      friends: [],
      isSubmit: false,
      loader: false,
      errorMsg: "",
      topicName: "",
      newlyAddedTopicMembers: [],
      updatedTopicMembers:[], // those members whose roles have been updated or existing members,
      removingUser: null,
      deleteLoader: false,
      removeUserModal: false,
      invitedEmailsList: [],
      changeTopicNamePermission: ['admin'],
      changeTopicTypePermission: ['admin'],
      addNewUserPermission: ['admin'],
      changeAndRemoveEditorRolePermission: ['admin'],
      changeAndRemoveContributorRolePermission: ['admin', 'editor'],
      requestAdminAccessLoader:false,
      requestEditorAccessLoader:false,
      searchUserLoader:false

    }
  },
  mounted() {
    this.topicName = this.topicToBeManage.name
    this.$refs.topicManagementBody.addEventListener('click', (event)=>{
      // used to handle click inside of this component
      const element = this.$refs.manageTopicRoles
       const className ='manage-topics-roles-section__section--search-users-dropdown'

      if (element){
        if (element.$el.contains(event.target)) {
          const targetElement = event.target;

          // Check if the clicked element or any of its ancestors has the specific class
          if (targetElement.classList.contains(className) || targetElement.closest(`.${className}`)) {
            //pass
          } else {
            // If clicked outside of the element or inside it but without the class, hide the dropdown
            element.hideDropdown(); // Assuming element has the hideDropdown method
          }
        }else{
          element.hideDropdown();
        }
      }
    })
  },
  computed: {
    ...mapGetters({
        selectedModule: 'discover/selectedModule',
        userFriends: 'profile/getFriends',
        topicNonInvitedUsers: 'discover/topicNonInvitedUsers'
    }),
    disableButton() {
      let state;
      if (this.newlyAddedTopicMembers.length == 0 &&
          this.updatedTopicMembers.length == 0 &&
          this.invitedEmailsList.length == 0 && 
          this.audienceChoice == 'Change Type' &&
          this.topicName === this.topicToBeManage.name) {
        state = true;
      }
      else {
        state = false;
      }
      return state;
    },
    topicDetails() {
      return this.$store.getters["article/getInterestGroup"];
    },
    type() {
      var topic;
      if (this.topicDetails.length < 2) {
        topic = 'Private'
      } else {
        topic = 'Public'
      }
      return topic;
    },
    users() {
      var users;
      if (this.type === 'Private') {
        users = this.topicDetails[0];
      } else {
        users = this.topicDetails[1];
      }
      return users
    },
    topicOptions(){
      return this.$store.getters["profile/getUserInterests"];
    },
    interestGroupId(){
      return this.$store.getters["article/getInterestGroupId"];
    },
    randomId() {
      const currentDate = new Date();
      const timestamp = currentDate.getTime();
      return timestamp;
    },
    isNewModuleActive(){
      return this.selectedModule === 'Trending News' || this.selectedModule === 'news-tab' ? true : false
    },
    preSelectedUsers(){
      if (this.users){
        const created_by = this.topicDetails.length > 0 ? this.topicDetails[0]?.created_by : ''
        const admins = this.users?.admins.map(user=>({...user, role:'admin', status:'active', created_by}))
        const editors = this.users?.editors.map(user=>({...user, role:'editor', status:'active', created_by}))
        const contributors = this.users?.contributors.map(user=>({...user, role:'contributor', status:'active', created_by}))
        const pending_invitations_admins = this.users?.pending_invitations_admins.map(user=>({...user, role:'admin', status:'pending', created_by}))
        const pending_invitations_editors = this.users?.pending_invitations_editors.map(user=>({...user, role:'editor', status:'pending', created_by}))
        const pending_invitations_contributors = this.users?.pending_invitations_contributors.map(user=>({...user, role:'contributor', status:'pending', created_by}))
        const selectedUsers = [...admins, ...editors, ...contributors, ...pending_invitations_admins, ...pending_invitations_editors, ...pending_invitations_contributors]
        return selectedUsers
      }else{
        return []
      }
    },
    
  },
  methods: {
    ...mapActions({
      setTopicNonInvitedUsers: 'discover/setTopicNonInvitedUsers',
      sendAdminOrEditorAccessRequest: 'discover/sendAdminOrEditorAccessRequest',
      fetchUninvitedTopicUsers: 'discover/fetchUninvitedTopicUsers'
    }),
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
    // async fetchAllUsers(value) {
    //   try {
    //     this.contactOptions = [];
    //     this.onUsersRequest = true;
    //     this.debounce(async () => {
    //       const payload = {
    //         searchName: value,
    //       };
    //       const response = await this.$store.dispatch(
    //         "profile/getUsersList",
    //         payload
    //       );
    //       if (response.status == 200) {
    //         response.data.map(async (val) => {
    //           if (val.profile) {
    //             let userList = {
    //               label: val.profile.full_name,
    //               value: val.id,
    //               key: val.email,
    //               icon: val.profile.profile_picture,
    //             };
    //             this.contactOptions.push(userList);
    //             await this.$store.commit(
    //               "profile/setContacts",
    //               this.contactOptions
    //             );
    //             return userList;
    //           }
    //         });
    //         this.onUsersRequest = false;
    //       }
    //     }, 1000);
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    fetchedSelectionAdmin(val) {
      this.selectedConnectionsAdmins = val;
    },
    fetchedSelectionEditors(val) {
      this.selectedConnectionsEditors = val;
    },
    fetchedSelectionContributors(val) {
      this.selectedConnectionsContributors = val;
    },
    addAdmins() {
      this.emptyTagifyInputAdmin = false;
      const newUsers = this.selectedConnectionsAdmins.map((user) => {
        if(Object.hasOwn(user,'id')){
        return {
          id: user.id,
          full_name: user.value,
          profile_picture: user.icon,
          email: user.email
        };
      }
      }).filter(user=>user);

      // change create a function for erwmoving duplicates and pass on the array to the function and return back
      const removingDuplicates = newUsers.filter(newUser => (
        !this.users.admins.some(existingUser => existingUser.id === newUser.id) &&
        !this.users.pending_invitations_admins.some(existingUser => existingUser.id === newUser.id)
      ));


      this.newAdmins = [...removingDuplicates];
      this.users.pending_invitations_admins = [...this.users.pending_invitations_admins, ...removingDuplicates];

      this.selectedConnectionsAdmins = [];
      this.emptyTagifyInputAdmin = true;
    },
    addEditors() {
      this.emptyTagifyInput = false;
      const newUsers = this.selectedConnectionsEditors.map((user) => {
        if(Object.hasOwn(user,'id')){
        return {
          id: user.id,
          full_name: user.value,
          profile_picture: user.icon,
          email: user.email
        };
      }
      }).filter(user=>user);

         // change create a function for erwmoving duplicates and pass on the array to the function and return back
      const removingDuplicates = newUsers.filter(newUser => (
        !this.users.editors.some(existingUser => existingUser.id === newUser.id) &&
        !this.users.pending_invitations_editors.some(existingUser => existingUser.id === newUser.id)
      ));
      this.newEditors = [...removingDuplicates]
      this.users.pending_invitations_editors = [...this.users.pending_invitations_editors, ...removingDuplicates];

      this.selectedConnectionsEditors = [];
      this.emptyTagifyInputEditor = true;
    },
    addContributors() {
      this.emptyTagifyInputContributor = false;
      const newUsers = this.selectedConnectionsContributors.map((user) => {
        if(Object.hasOwn(user,'id')){
        return {
          id: user.id,
          full_name: user.value,
          profile_picture: user.icon,
          email: user.email
        };
      }
      }).filter(user=>user);

         // change create a function for erwmoving duplicates and pass on the array to the function and return back
      const removingDuplicates = newUsers.filter(newUser => (
        !this.users.contributors.some(existingUser => existingUser.id === newUser.id) &&
        !this.users.pending_invitations_contributors.some(existingUser => existingUser.id === newUser.id)
      ));
      this.newContributors = [...removingDuplicates]
      this.users.pending_invitations_contributors = [...this.users.pending_invitations_contributors, ...removingDuplicates];

      this.selectedConnectionsContributors = [];
      this.emptyTagifyInputContributor = true;
    },
    async sendInvitation() {
      try {
        this.loader = true;
        if (this.audienceChoice !== 'Change Type' || this.topicName !== this.topicToBeManage.name) {
            const changeTopicTypePaylaod = {
              id: this.topicToBeManage.id,
              interest: this.topicName,
              is_private: this.audienceChoice === 'Change Type' ?  this.topicToBeManage?.is_private : this.audienceChoice === 'private' ? true : false,
            }
            const topic = await this.$store.dispatch('profile/updateInterest', changeTopicTypePaylaod); 
            this.emitter.emit('change-topic-type', topic)
        }
        // REPLACE STATIC URL WITH DYNAMIC URL

        const usersInvitations = this.newlyAddedTopicMembers.map(val => ({
          to_user: val.id,
          permission: val?.role,
          link: `?topic=${this.topicName.replaceAll(" ", "-")}&id=${this.topicToBeManage.id}`
        }));

        const updateUserRoles = this.updatedTopicMembers.filter(user=>user?.status !== 'pending').map(val => ({
          to_user: val.id,
          permission: val?.role,
        }));

        const pendingUserUpdatedRoles = this.updatedTopicMembers.filter(user=>user?.status === 'pending').map(val => ({
          to_user: val.id,
          permission: val?.role,
          link: `?topic=${this.topicName.replaceAll(" ", "-")}&id=${this.topicToBeManage.id}`
        }));

        const invitedEmails = this.invitedEmailsList.map(user=>({
          to_email: user.email,
          permission: user?.role,
          link: `?topic=${this.topicName.replaceAll(" ", "-")}&id=${this.topicToBeManage.id}`
        }))

        if (usersInvitations.length > 0 || pendingUserUpdatedRoles.length > 0  || updateUserRoles.length > 0 || invitedEmails.length > 0 ){
          const payload = {
            interest_group_id: this.interestGroupId,
            "users": updateUserRoles,
            "invitations": [...pendingUserUpdatedRoles, ...usersInvitations, ...invitedEmails]
          };
          
          // await this.$store.dispatch("article/inviteOnTopic", payload);        
          await this.$store.dispatch("article/inviteUserAndUpdateRoles", payload);        
          this.$store.dispatch('profile/getUserTopicsWithOrdering');
          this.$showToast({message:'Topic Management Updated Successfully', type:'success'})
        }
        } catch (err) {
          this.errorMsg = err?.response?.data?.error ?? '';
      }
      finally{
        this.loader = false
        this.$emit('closeDrawer')
      }
    },
    removeUser(user) { 
      this.removeUserModal = true
      this.removingUser = user
    },
    async fetchContacts() {
      try {
        this.options = [];
        const response = await this.$store.dispatch(
          "profile/getFriendsList"
        );
        if (response.status == 200) {
          this.options = response.data.results.map((user) => ({
                label: user.full_name,
                value: user.id,
                key: user.email,
                icon: user.profile_picture,
                id: user.id,
                email: user.email
              }));
        }
      } catch (err) {
        console.log(err);
      }
    }, 
    handleClickOutside(){
      // used to handle click out side of this component
      const element =  this.$refs.manageTopicRoles
      if (element){
        element.hideDropdown()
      }
    },
    fetchNewlyAddedTopicMembers(members){
      this.newlyAddedTopicMembers = [...members]
    },
    fetchUpdateTopicMembers(members){
      this.updatedTopicMembers = [...members]
    },
    async removeExistingUser(){
      try {
        this.deleteLoader = true
        if (this.removingUser?.status === 'pending')
          await this.$store.dispatch('article/removePendingUserFromTopic', { id:this.interestGroupId, user_id:this.removingUser?.id });
        else if (this.removingUser?.status === 'active')
          await this.$store.dispatch('article/removeActiveUserFromTopic', { id:this.interestGroupId, user_id:this.removingUser?.id, kick:true });
        this.emitter.emit('remove-existing-user-manage-topic-roles', this.removingUser)
        // await this.fetchUninvitedTopicUsers()
        this.removeUserModal = false
        this.$showToast({message:'User removed successfully', type:'success'})
      } catch (err) {
        console.log(err);
      }finally{
        this.deleteLoader = false
        this.removeUserModal = false
      }
    },
    updateSelectedEmails(emailList){
      this.invitedEmailsList = emailList
    },
    async requestForAdminAccess(){
      try{
        this.requestAdminAccessLoader = true
        await this.sendAdminOrEditorAccessRequest({permission:'admin' })
        this.$showToast({message:'Request for admin access sent', type:'success'})
      }
      catch(err){
        this.errorMsg = err?.response?.data?.non_field_errors[0] ?? '';
        if (this.errorMsg)
          this.$showToast({message:this.errorMsg, type:'failure'})
      }
      finally{
        this.requestAdminAccessLoader = false
        this.$emit('closeDrawer')
      }
    },
    async requestForEditorAccess(){
      try{
        this.requestEditorAccessLoader = true
        await this.sendAdminOrEditorAccessRequest({permission:'editor' })
        this.$showToast({message:'Request for editor access sent', type:'success'})
      }
      catch(err){
        this.errorMsg = err?.response?.data?.non_field_errors[0] ?? '';
        if (this.errorMsg)
          this.$showToast({message:this.errorMsg, type:'failure'})
      }
      finally{
        this.requestEditorAccessLoader = false
        this.$emit('closeDrawer')
      }
    },
    async searchUser(searchValue) {
      try{
        this.searchUserLoader = true
        await this.fetchUninvitedTopicUsers({search:searchValue})
        this.searchUserLoader = false
      }catch(err){
        console.log(err)
      }finally{
        this.searchUserLoader = false
      }
    }
  }
};
</script>
<style lang="scss">
.tab-management-container {
  &__body {
    padding: 0 2.5rem;
    overflow-y: auto;
    height: calc(100vh - 21.5rem);
    overflow-x: hidden;
    &--section {
      padding-bottom: 2rem;
      margin-bottom: 3rem;
      border-bottom: 1px solid $color-dark-grey-5;
      &:last-child {
        margin-bottom: 0;
        border-bottom: none;
      }
      &--msg {
        color: red;
      }
      &--header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1.6rem;
        .title {
          font-size: 1.6rem;
          font-family: $font-primary-medium;
          line-height: 2.2rem;
          margin-bottom: 0;
          color: $color-black;
        }
        .btn {
          width: 11rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          line-height: 1.4rem;
          color: $color-white;
          background-color: $color-primary;
          font-family: $font-primary;
          outline: none;
          border: none;
          border-radius: 5px !important;
          height: 3rem;
          margin-left: 1.4rem;
          cursor: pointer;
          .icon {
            margin-right: 0.7rem;
            font-size: 1rem;
            color: $color-white;
            line-height: normal;
          }
        }
        .contributors-btn {
          width: 13rem;
        }
      }
      .privacy-settings {
        &__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 2rem;
          &--name {
            display: flex;
            align-items: center;
            img {
              width: 2rem;
              height: auto;
            }
            p {
              font-size: 1.4rem;
              font-family: $font-primary;
              line-height: 1.8rem;
              margin-bottom: 0;
              color: $color-black;
              margin-left: 0.6rem;
            }
          }
          &--select {
            border: none;
            outline: none;
            box-shadow: none;
            color: $color-white;
            opacity: 1;
            .ant-select-selector {
              background-color: $color-primary;
              color: $color-white !important;
              min-width: 11.5rem;
              height: 3.5rem !important;
              border-radius: 5px !important;
              border: none;
              outline: none !important;
              box-shadow: none !important;
              padding: 0 1.5rem;
              .ant-select-selection-item {
                height: 100%;
                display: flex;
                padding-right: 0rem;
                align-items: center;
                font-size: 1.2rem;
                font-family: $font-primary;
                .select-item {
                  display: flex;
                  img {
                    margin-top: -0.2rem;
                  }
                  .white-icon {
                    display: block !important;
                  }
                  .black-icon {
                    display: none !important;
                  }
                }
              }
            }
            .ant-select-arrow {
              right: 1.5rem;
              width: 1rem;
              .anticon {
                font-size: 1rem;
                svg {
                  fill: $color-white;
                }
              }
            }
          }
        }
        &__body {
          margin-top: 1.6rem;
          p {
            font-size: 1.4rem;
            font-family: $font-primary;
            line-height: 1.8rem;
            margin-bottom: 0;
            color: $color-black;
            opacity: 0.6;
            padding-right: 2rem;
          }
        }
      }
      &--search-user {
        position: relative;
        width: 100%;
        border: 1px solid #00000033;
        border-radius: 0.5rem;
        background-color: $color-white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tagify {
          border: none;
          background-color: transparent;
          padding-left: 0.6rem;
          min-height: 3.9rem;
          max-height: 7.5rem;
          &__input {
            border: none;
            padding: 1.2rem 1.2rem 1.2rem 0.6rem;
            height: 3.9rem;
          }
        }
        &::-webkit-scrollbar-track {
          background-color: #ffffff3f;
          height: 2px;
        }
        &::-webkit-scrollbar {
          width: 3px;
          background-color: rgb(224, 224, 224);
          border-radius: 3rem;
          height: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: $color-primary;
          border-radius: 3rem;
        }
      }
      &--active-admin {
        margin-top: 2.6rem;
        .header {
          margin-bottom: 1.8rem;
          h2 {
            font-size: 1.4rem;
            font-family: $font-primary;
            line-height: 2.2rem;
            margin-bottom: 1.8rem;
            color: $color-black;
          }
        }
        .body {
          display: flex;
          align-items: center;
          overflow-x: auto;
          padding-bottom: 1.5rem;
          &::-webkit-scrollbar-track {
            background-color: #ffffff3f;
            height: 2px;
          }
          &::-webkit-scrollbar {
            width: 3px;
            background-color: rgb(224, 224, 224);
            border-radius: 3rem;
            height: 4px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: $color-primary;
            border-radius: 3rem;
          }
          .message {
            font-size: 1.4rem;
            text-align: center;
            font-family: $font-primary;
            display: block;
            margin:  0 auto 2rem;
          }
        }
      }
      &--input {
        height: 4rem;
        padding: 1.2rem 1rem;
        border: 1px solid $color-dark-grey-4;
        outline: none;
        border-radius: 5px !important;
        width: 100%;
        font-size: 1.4rem;
        font-family: $font-primary;
        color: $color-black;
        &::placeholder {
          color: $color-placeholder;
        }
      }
    }
    &::-webkit-scrollbar-track {
      background-color: #ffffff3f;
    }
    &::-webkit-scrollbar {
      width: 4px;
      background-color: rgb(224, 224, 224);
      border-radius: 3rem;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $color-primary;
      border-radius: 3rem;
    }
  }
  &__footer {
    position: sticky;
    bottom: 0;
    padding: 2rem 2.5rem;
    background-color: $color-white;
    width: 100%;
    display:flex;
    flex-direction: row;
    .apply-btn {
      border: none;
      outline: none;
      background: $color-primary;
      font-size: 1.5rem;
      color: $color-white;
      width: 18rem;
      height: 4rem;
      font-family: $font-primary-medium;
      display: block;
      cursor: pointer;
      margin-left: auto;
      padding: 0 !important;
      &:hover,
      &:active,
      &:focus {
        background-color: $color-primary;
        color: $color-white;
      }
      &:disabled {
        opacity: 0.2;
        cursor: default;
      }
      .anticon {
        width: 100%;
        border-radius: 100px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          width: 2.5rem;
        }
      }
    }
  }
}
.public-topic-active {
  background-color: rgb(238, 238, 238) !important;
}
</style>
